import { useMemo } from 'react';

import useTranslation from './useTranslation';

export function useLanguageUrl() {
  const { lang } = useTranslation();

  const addLanguageToPath = useMemo(() => {
    return (path: string): string => {
      const pathWithoutLang = path.replace(/^\/[a-z]{2}\//, '/');

      if (lang === 'pl') {
        return pathWithoutLang === '/' ? '/' : pathWithoutLang;
      }

      return `/${lang}${pathWithoutLang}`;
    };
  }, [lang]);

  return addLanguageToPath;
}
